class TestExecutionLogController {
    constructor($window, $route, $location, $browser, $scope, ModalService, $timeout, UserDetailsApi, toastr, MtExLogServiceApi, TraceHubExService, NewTracesExService, TraceDetailsServiceApi, ViewMediaModalService, TestExecutionServiceApi, TraceClassService, AppServiceApi) {
        this.signalRComponentName = 'test-execution-log';
        this.$onInit = () => {
            this.init();
        };
        this.$onDestroy = () => {
            this.TraceHubExService.stop(this.signalRComponentName);
        };
        this.init = () => {
            this.tvNodes = [];
            this.userDetails = null;
            this.context = {
                selectedNodes: [],
                selectedTraceId: 0,
                traceClass: this.TraceClassService.traceClass,
                subTraceClass: this.TraceClassService.subTraceClass
            };
            this.selectedExLog = '';
            this.connectionId = '0';
            this.state = {
                exeLogLoading: true
            };
            // TODO: Check if we only need the testerId for the exLog
            this.UserDetailsApi.get().then((response) => {
                let connectedUser = response.data;
                // Get our user details
                this.userDetails = connectedUser;
                // get the user, then the settings, then fire the request for the execution log
                // as user and settings are required inputs for fetching the log.
                this.AppServiceApi.settings().then((response) => {
                    if (response.data) {
                        this.TraceHubExService.connectWithSpecificTransport(this.signalRComponentName, response.data.SignalRTransport);
                        // Set the connectionId on vm.state.connectionId
                        this.TraceHubExService.on(this.signalRComponentName, 'onInit', (connId) => {
                            this.connectionId = connId;
                        });
                        // The SignalR server raises the onNewTraces event
                        this.TraceHubExService.on(this.signalRComponentName, 'onNewTraces', (dto) => {
                            if (dto.ConnectionId !== this.connectionId) {
                                return;
                            }
                            if (dto.TreeViewNodes.length > 0 && this.autoRefresh) {
                                this.getExecutionLog();
                            }
                        });
                        this.maxNumLogResults = response.data.TestExecutionResultViewLimit;
                        this.getExecutionLog();
                    }
                });
            }, () => {
                this.toastr.error('Please make sure that you are logged in!');
                this.window.location.href =
                    this.browser.baseHref() + 'account/login';
                return;
            });
            this.$scope.$on("testExecutionLogRefresh", () => this.getExecutionLog());
        };
        // TODO: Figure out what we are getting from onNewTraces
        // It TraceTreeViewModel[] => how do we handle this in UtpTraceSummary?
        this.processNewTraces = (newNodes, mtCertNodes) => {
            if (newNodes.length === 0) {
                return [];
            }
            // Fix timestamp for newNodes
            let nonDuplicateNewRows = this.NewTracesExService.removeDuplicateTvNodes(newNodes, mtCertNodes);
            // sort by timestamp desc
            let sortAsc = _.sortBy(nonDuplicateNewRows, ['traceId']);
            let sortDesc = sortAsc.reverse();
            return sortDesc;
        };
        this.getExecutionLog = () => {
            this.TestExecutionServiceApi.getExecutionLog(this.testerId, this.simulatorId, this.maxNumLogResults).then((response) => {
                let tvNodes = response.data;
                this.tvNodes = tvNodes;
                this.state.exeLogLoading = false;
            });
        };
        this.options = {
            onExpand: ($event, node, context) => {
                // disable the autoRefresh when the user manually expand a node
                this.autoRefresh = false;
                if (node.$model.nodeType === 'unsolicited') {
                    if (!node.$model.loaded) {
                        this.renderMultipleExLogChildren(node, context);
                    }
                    return;
                }
                if (node.$model.MessageType === 'raw-message') {
                    this.showRawMessage(node.$model.traceId, node, context);
                    return;
                }
                else if (node.$model.MessageType !== 'CryptoSubItem') {
                    this.renderNodeChildren(node, context);
                }
            },
            onSelect: ($event, node, context) => {
                // disable the autoRefresh when the user manually select a node
                this.autoRefresh = false;
                this.context.selectedTraceId = null;
                this.context.selectedNodes = [node];
                this.selectedExLog = node.$model.label;
            }
        };
        this.showRawMessage = (traceId, node, context) => {
            this.TraceDetailsServiceApi.getRawMessage(traceId, true).then((response) => {
                let media = response.data;
                try {
                    // If the content is JSON then we'll defer to the server because it will format it all nicely for us
                    let obj = JSON.parse(media.Content);
                    if (obj && typeof obj === 'object') {
                        this.renderNodeChildren(node, context);
                        return;
                    }
                }
                catch (e) { }
                this.ViewMediaModalService.open(media);
                // Collapse node after delay
                this.timeout(() => {
                    node.collapsed = true;
                }, 300);
            });
        };
        this.renderNodeChildren = (node, context) => {
            if (node.$model.nodeType === 'cert') {
                this.renderExLogChildren(node, context);
                return;
            }
            if (!node.$model.loaded) {
                this.renderTraceChildren(node, context);
                return;
            }
        };
        this.renderTraceChildren = (node, context) => {
            let traceId = node.$model.traceId;
            let loaded = node.$model.loaded;
            this.context.selectedNodes = [node];
            if (traceId > 0 && !loaded) {
                this.MtExLogServiceApi.getTraceChildren(traceId).then((response) => {
                    node.$model.children = response.data;
                    node.$children = context.nodifyArray(response.data);
                    this.nodifyChildren(node, context); // Do this to populate grandchildren
                    node.$model.loaded = true;
                });
            }
        };
        this.renderMultipleExLogChildren = (node, context) => {
            let mtCertRequests = [];
            for (let childNode of node.$children) {
                childNode.$model.label = 'Loading...';
                childNode.$hasChildren = false;
                mtCertRequests.push({
                    TesterId: node.$model.UserId,
                    ProjectIterationId: node.$model.ProjectIterationId,
                    SimId: node.$model.SimId,
                    SuiteId: node.$model.SuiteId,
                    TestId: node.$model.TestId,
                    TraceUid: childNode.$model.TraceUid
                });
            }
            this.MtExLogServiceApi.multipleMtExLogNodeChildren(mtCertRequests).then((response) => {
                node.$model.children = response.data;
                node.$children = context.nodifyArray(response.data);
                this.nodifyChildren(node, context); // Do this to populate grandchildren
                node.$model.loaded = true;
            });
        };
        this.renderExLogChildren = (node, context) => {
            let loaded = node.$model.loaded;
            this.context.selectedNodes = [node];
            let model = node.$model;
            let mtCertRequest = {
                TesterId: model.UserId,
                ProjectIterationId: model.ProjectIterationId,
                SimId: model.SimId,
                SuiteId: model.SuiteId,
                TestId: model.TestId,
                TraceUid: model.TraceUid
            };
            if (!loaded) {
                this.MtExLogServiceApi.mtExLogNodeChildren(mtCertRequest).then((response) => {
                    node.$model.children = response.data;
                    node.$children = context.nodifyArray(response.data);
                    this.nodifyChildren(node, context); // Do this to populate grandchildren
                    node.$model.loaded = true;
                });
            }
        };
        this.nodifyChildren = (node, context) => {
            this.timeout(() => {
                angular.forEach(node.$children, (node) => {
                    if (node.$hasChildren) {
                        let options = {};
                        let children = node.$model.children;
                        node.$children = context.nodifyArray(children, node, options);
                    }
                });
            });
        };
        this.viewTraceSummary = () => {
            let route = '/TraceSummary';
            this.location.path(route);
        };
        this.window = $window;
        this.browser = $browser;
        this.ModalService = ModalService;
        this.timeout = $timeout;
        this.UserDetailsApi = UserDetailsApi;
        this.toastr = toastr;
        this.location = $location;
        this.route = $route;
        this.MtExLogServiceApi = MtExLogServiceApi;
        this.TraceHubExService = TraceHubExService;
        this.NewTracesExService = NewTracesExService;
        this.TraceDetailsServiceApi = TraceDetailsServiceApi;
        this.ViewMediaModalService = ViewMediaModalService;
        this.TestExecutionServiceApi = TestExecutionServiceApi;
        this.TraceClassService = TraceClassService;
        this.AppServiceApi = AppServiceApi;
        this.$scope = $scope;
    }
}
angular.module('app').component('testExecutionLog', {
    bindings: {
        testerId: '<',
        simulatorId: '<',
        autoRefresh: '='
    },
    controllerAs: 'vm',
    controller: TestExecutionLogController,
    templateUrl: 'scripts/app/partials/TestExecution/test-execution-log.tpl.html'
});
